import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Star = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 25 2.605469 C 25.59375 2.605469 26.136719 2.941406 26.402344 3.472656 L 32.476562 15.777344 L 46.058594 17.765625 C 46.648438 17.851562 47.136719 18.265625 47.320312 18.832031 C 47.503906 19.394531 47.347656 20.015625 46.921875 20.433594 L 37.09375 30.003906 L 39.414062 43.527344 C 39.515625 44.113281 39.273438 44.707031 38.792969 45.054688 C 38.3125 45.40625 37.675781 45.449219 37.148438 45.171875 L 25 38.785156 L 12.851562 45.171875 C 12.324219 45.449219 11.6875 45.40625 11.207031 45.054688 C 10.726562 44.707031 10.484375 44.113281 10.585938 43.527344 L 12.902344 30.003906 L 3.074219 20.433594 C 2.648438 20.015625 2.496094 19.394531 2.679688 18.832031 C 2.863281 18.265625 3.351562 17.851562 3.941406 17.765625 L 17.523438 15.777344 L 23.597656 3.472656 L 23.710938 3.285156 C 24 2.863281 24.480469 2.605469 25 2.605469 Z M 19.964844 17.898438 C 19.738281 18.359375 19.296875 18.679688 18.789062 18.753906 L 7.523438 20.398438 L 15.671875 28.339844 C 16.042969 28.695312 16.210938 29.214844 16.125 29.722656 L 14.199219 40.933594 L 24.273438 35.636719 L 24.445312 35.558594 C 24.863281 35.402344 25.328125 35.429688 25.726562 35.636719 L 35.800781 40.933594 L 33.875 29.722656 C 33.789062 29.214844 33.957031 28.695312 34.324219 28.339844 L 42.472656 20.398438 L 31.210938 18.753906 C 30.703125 18.679688 30.261719 18.359375 30.035156 17.898438 L 25 7.695312 Z M 19.964844 17.898438 "
        fill={color}
      />
    </svg>
  )
}
